import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-review-type',
	templateUrl: './review-type.component.html',
	styleUrls: ['./review-type.component.css']
})
export class ReviewTypeComponent implements OnInit, OnChanges {
	@Input() isComplaint: any; @Input() description: string;
	@Input() column = false;
	constructor() { }

	ngOnChanges(changes: SimpleChanges) {
		if (changes.isComplaint) {
			// console.log('data.....');
			// console.log(this.isComplaint);
		}

	}

	ngOnInit() {
	}

}
